import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Tiltak } from "../../models/oppsummering.model";

@Injectable({
  providedIn: "root",
})

export class TiltakApiService{
  private http = inject(HttpClient);
  getTiltak(id: number, besvarelseId?: string): Observable<Tiltak> {
    let params = new HttpParams();
    if (besvarelseId) {
      params = params.set("besvarelseId", besvarelseId);
    }
    return this.http.get<Tiltak>(`/api/tiltak/${id}`, { params })
  }


}
